export default __webpack_public_path__ + "static/media/art.bf0ad196.png";